import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  // displayedColumns = [ 'UsersCode', 'FcDesc'];
  UsersForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  UsersList: any;
  list;
  isread = false;
  isreaddelete = false;
  Usersform: any;
  UsersSearchForm;
  APIService: any;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  // jsonData: any;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
    private route: ActivatedRoute, ) { this.APIService = environment.serviceUrl; }

  // download(){
  //   const wwe = ['FcCode', 'FcDesc'];
  //   this.umsService.downloadFile(this.UsersList, 'jsontocsv', wwe);
  // }

  ngOnInit(): void {
    this.submitButton = true;
    this.editButton = false;
    this.list = true;
    this.UsersForm = this.fb.group({
      // FcCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      // FcDesc: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
    });
    // this.UsersSearchForm = this.fb.group({
      // FcCode: new FormControl (''),
      // FilterType: new FormControl ('LIKE'),
    // });
    // this.getUsersData();
  }

  keypress(){
    this.UsersList = [];
    this.umsService.searchUser(this.UsersSearchForm.value).subscribe(res => {
      this.UsersList = res.data;
      }, (ERROR: HttpErrorResponse) => {
        this.UsersList = [];
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     });
  }

  getUsersData() {
    const payload = {};
    this.umsService.getUser(payload).subscribe(res => {
      this.UsersList = res.data;
      // this.openDialog(res);
      // this.dataSource = new MatTableDataSource(this.UsersList);
      }, (ERROR: HttpErrorResponse) => {
        this.UsersList = [];
        // tslint:disable-next-line:prefer-const
        let  data = {};
        // tslint:disable-next-line:no-string-literal
        data['message'] = ERROR.error.message;
        // tslint:disable-next-line:no-string-literal
        data['title'] = 'Information';
        // tslint:disable-next-line:no-string-literal
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     });
  }

  prepopulation(id) {
    const payload = {};
    this.umsService.getUser(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status){
         this.editButton = true;
         this.submitButton = false;
         this.isread = true;
         this.deleteButton  = false;
         this.UsersForm = this.fb.group({
          // FcCode: new FormControl (data.FcCode, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          // FcDesc: new FormControl (data.FcDesc, [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
        });
       }else{
         this.umsService.openSnackbar(res.message);
       }
     });
  }

   deletee(e, k){
    if (e === 'true'){
      this.list = false;
      this.getUsersData();
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }
  prepopulationForDelete(id){
    const payload = {};
    // tslint:disable-next-line:no-string-literal
    // payload['FcCode'] = id.FcCode;
    // tslint:disable-next-line:no-string-literal
    // payload['FcDesc'] = id.FcDesc;
    this.umsService.getUser(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        this.isreaddelete = true;
        this.deleteButton = true;
        this.UsersForm = this.fb.group({
          // FcCode: new FormControl (data.FcCode, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          // FcDesc: new FormControl (data.FcDesc, [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),

        });
      } else {
        let  data = {}
        // tslint:disable-next-line:no-string-literal
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  openConformationModalBox(){
    const  data = {};
    // tslint:disable-next-line:no-string-literal
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    // tslint:disable-next-line:no-string-literal
    data['title'] = 'Alert';
    // tslint:disable-next-line:no-string-literal
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes'){
        this.deletedata(this.UsersForm.value);
      }
    });
   }
   deletedata(id){
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
      // FcCode: id.FcCode,
      // FcDesc: id.FcDesc
    },
  };
    this.httpClient.delete(this.APIService + '/masters/Users', options)
    .subscribe((s) => {
      let cc = [];
      cc.push(s);
      let  data = {}
      data['message'] = cc[0].message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        // this.ngOnInit();
      });
    },(ERROR: HttpErrorResponse) => {
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

   });

   }

  submit(){
    if (this.UsersForm.valid) {
      this.Users();
    } 
  }

  Users() {
    this.submitpayload = this.UsersForm.value;
    this.umsService.addUser(this.submitpayload).subscribe(res => {
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        let  data = {}
        // tslint:disable-next-line:no-string-literal
        data['message'] = res.message
        // tslint:disable-next-line:no-string-literal
        data['title'] = 'Information'
        // tslint:disable-next-line:no-string-literal
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.umsService.openSnackbar(res.message);
        // this.umsService.openSnackbar(res.message);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.UsersList = [];
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  update(){
    if (this.UsersForm.invalid) {
      // this.UsersForm.get('FcCode').markAsTouched();
      // this.UsersForm.get('FcDesc').markAsTouched();
      return;
    } else {
      this.updateUsers();
    }
  }

  updateUsers() {
    // 403 code error handling needed to be given
    this.submitpayload = this.UsersForm.value;
    this.umsService.updateUser(this.submitpayload).subscribe(res => {
      
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       // this.umsService.openSnackbar(res.message);
        // this.ngOnInit();
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.umsService.openSnackbar(res.message);
        // this.ngOnInit();
      }
    });
  }

  addnewrecord(e){
    if (e === 'true'){
      this.list = false;
      this.editButton = false;
      this.submitButton = true;
      this.isreaddelete = false;
      this.deleteButton = false;
      this.isread = false;
      this.UsersForm = this.fb.group({
        // FcCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        // FcDesc: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z-&\\s]*$')]),
      });
    } else {
      this.list = true;
      // this.getUsersData();
    }
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      // this.isread = false;
      this.getUsersData();
      this.Usersform = k;
      this.prepopulation(this.Usersform);
    } else {
      this.list = true;
    }
  }


  downloadMyFile(){
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', '../../assets/SampleTemplate.csv');
    link.setAttribute('download', `Sample Template.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  redirect(to): void {
    this.router.navigate([to]);
   }


   openDialog(id) {
   const  data = {};
   // tslint:disable-next-line:no-string-literal
   data['message'] = id.message;
   // tslint:disable-next-line:no-string-literal
   data['title'] = 'Information';
   // tslint:disable-next-line:no-string-literal
   data['icon'] = 'fas fa-trash';
   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }
}
